import { render, staticRenderFns } from "./gameResultOthersExportFull.vue?vue&type=template&id=10acc485&lang=pug"
import script from "./gameResultOthersExportFull.vue?vue&type=script&lang=js"
export * from "./gameResultOthersExportFull.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports